// removed by extract-text-webpack-plugin
module.exports = {"SenderInfoWrapper":"SenderInfoWrapper---LL6XR","SenderInfo":"SenderInfo---GClY7","OrgName":"OrgName---3sw1X"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/shared-web/src/components/widget/TakeoverCampaign/SenderInfo/style.styl
// module id = bMex
// module chunks = 88